import { layoutOf } from '../../domain/layout';
import { singleAxle } from '../wheel-placements';
import { ADT } from './dimensions';

const ADT_WHEELS = ADT.axles.flatMap((axle, index) => singleAxle({
  axle: index + 1,
  x: axle.x,
  radius: ADT.wheelRadius,
  width: ADT.tyreWidth,
  halfTrack: axle.halfTrack,
}));

const ADT_LAYOUT = layoutOf(['single', 'single', 'single']);

export {
  ADT_LAYOUT,
  ADT_WHEELS,
};
